(function ($, window, document, undefined) {
	$(function () {
		/**
		 *  Auth forms processing (validate, submit)
		 */
		function authFormsProcessing() {
			$(".rewards-form-register .validate-required input").on("change keyup", function () {
				let idInput = $(this).attr("id");

				if ($(this).val().trim().length) {
					$(this).removeClass("input-error");
					$(".message-error." + idInput).hide();
				} else {
					$(this).addClass("input-error");
					$(".message-error." + idInput).show();
				}
			});

			$(".rewards-form-register .validate-required input[type='checkbox']").on("change", function () {
				let idInput = $(this).attr("id");

				if ($(this).is(":checked")) {
					$(this).removeClass("input-error");
					$(".message-error." + idInput).hide();
					console.log("Ok");
				} else {
					$(this).addClass("input-error");
					$(".message-error." + idInput).show();
					console.log("Not ok");
				}
			});

			$(".rewards-form-register .validate-required [name='email']").on("change keyup", function () {
				let idInput = $(this).attr("id");
				let inputvalues = $(this).val();
				let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

				$(this).removeClass("input-error");

				if (!regex.test(inputvalues)) {
					$(this).addClass("input-error");
					$(".message-error." + idInput).show();
				} else {
					$(this).removeClass("input-error");
					$(".message-error." + idInput).hide();
				}
			});

			const register = $("form.rewards-form-register .submit");
			register.on("click", function (e) {
				e.preventDefault()
				e.stopPropagation()

				const $btn = $(this);
				$btn.attr("disabled", "disabled");

				let $data = {
					action: "kp_rewards_register",
				}
				$("form.rewards-form-register").find("input, textarea").not("input[type='checkbox']").each(function () {
					$data[this.name] = $(this).val();
				});

				$("form.rewards-form-register").find("input[type='checkbox']").each(function () {
					if ($(this).prop("checked")) {
						$data[this.name] = "checked";
					} else {
						$data[this.name] = "";
					}
				});

				jQuery.ajax({
					url: kp_auth.ajax,
					dataType: "json",
					type: "post",
					data: $data,
					beforeSend: function () { },
					success: function (msg) {
						console.log(msg.data);
						if (msg.success) {
							if (msg.data.email) {
								jQuery('.verify-email__email-address').text(msg.data.email);
								jQuery('.verify-email__subtitle').text('You\'re almost There! We sent an email to');
							}
							if (msg.data.user) {
								kp_auth.user = msg.data.user;
							}
							jQuery('.verify-email').show();
							jQuery('.rewards-form-register').hide();
						} else {
							$("input, select").removeClass("input-error");
							$(".message-error").remove();

							for (key in msg.data) {
								$(`#${key}`).addClass("input-error");
								$(`#${key}`).parent().append(`<p class="message-error">${msg.data[key]}</p>`);
							}
						}
					},
					error: function () {
						alert("Send Error")
						return false;
					},
					complete: function () {
						$btn.removeAttr("disabled");
					}
				});
			});

			jQuery(document).on("click", '.verify-email-resend__button', function (e) {
				e.preventDefault()
				e.stopPropagation()

				const $btn = $(this);
				$btn.attr("disabled", "disabled");

				let $data = {
					action: "kp_deals_resend_verify_email",
					_nonce: kp_auth.nonce,
					user: kp_auth.user,
				}

				$btn.text('SENDING...');

				jQuery.ajax({
					url: kp_auth.ajax,
					dataType: "json",
					type: "post",
					data: $data,
					beforeSend: function () { },
					success: function (msg) {
						console.log(msg.data);
						if (msg.success) {
							$btn.text('EMAIL IS SENT');
						} else {
							$btn.text('OOPS, RELOAD THE PAGE PLEASE');
							$btn.closest('.verify-email-resend').find('.switch-form').remove()
							$btn.closest('.verify-email-resend').append(`<div class="switch-form">If you have already created account <a href="/auth/">Sign In</a></div>`);
						}
					},
					error: function () {
						$btn.text('OOPS, RELOAD THE PAGE PLEASE');
						return false;
					},
					complete: function () {
						$btn.removeAttr("disabled");
					}
				});
			});

			jQuery(document).on("click", '.checkagreetripple', function (e) {
				e.preventDefault()
				e.stopPropagation()

				const $btn = $(this);
				let url = new URL($btn.attr('href'));
				if ($('input#agree-tripple').prop('checked') && $('input#agree-tripple').val() !== 'undefined') {
					url.searchParams.set('tripple', 1);
					url.searchParams.set('user', $('input#agree-tripple').val());
				}

				window.location.href = url.toString();
			});


		}

		/**
		 * Toggle password visibility
		 */
		function togglePasswordVisibility() {
			$(".toggle-password").on("click", function () {
				if ($(this).parent().find("input[type='password']").attr("type") === "password") {
					$(this).parent().find("input[type='password']").attr("type", "text");
				} else {
					$(this).parent().find("input[type='text']").attr("type", "password");
				}

				$(this).find(".hidden-icon, .showed-icon").toggleClass("hidden");
			});
		}

		function init() {
			authFormsProcessing();
			togglePasswordVisibility();
		}

		init();
	});
})(jQuery, window, document);
